var _this = this;

export var toChinesNum = function toChinesNum(n, isComplex) {
	var s = "负";
	var temp = 0;
	var MAX = 9999999999999.99;
	var MIN = -9999999999999.99;
	var ret = "";
	if (n > MAX) {
		ret = "数据过大！";
	} else if (n < MIN) {
		ret = "数据过小！";
	} else {
		if (Number(n) < 0) {
			temp = n;
			n = String(n).substring(1, String(n).length);
		}
		var unit = "万仟佰拾亿仟佰拾万仟佰拾点",
		    str = "";
		n += "00";
		var p = n.indexOf(".");
		if (p >= 0) {
			n = n.substring(0, p) + n.substr(p + 1, 2);
		}
		unit = unit.substr(unit.length - n.length + 2);
		for (var i = 0; i < n.length; i++) {
			str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
		}
		if (str == "零点零零") {
			ret = "零";
		} else {
			ret = str.replace(/点零零/g, "").replace(/零(仟|佰|拾)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿)/g, "$1").replace(/(亿)万/g, "$1").replace(/零$/g, "");
		}
	}
	return ret;
};

export var formatMoney = function formatMoney(e) {
	return e.replace(/,/g, "");
};

export var updateCardNo = function updateCardNo(idcard) {
	var SS = void 0,
	    Y = void 0,
	    M = void 0,
	    JYM = void 0,
	    ereg = void 0,
	    idcard_array = new Array();
	if (idcard.length !== 15) {
		return idcard;
	}

	if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || (parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0) {
		ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
	} else {
		ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
	}
	if (!ereg.test(idcard)) {
		return idcard;
	}
	idcard = idcard.substr(0, 6) + "19" + idcard.substr(6);
	idcard_array = idcard.split("");

	SS = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
	Y = SS % 11;
	M = "F";
	JYM = "10X98765432";
	M = JYM.substr(Y, 1);
	return idcard + M;
};

export var objToArr = function objToArr(object) {
	var arr = [];

	for (var key in object) {
		var item = {};
		item.key = key;
		item.value = object.key;
		arr.push(item);
	}

	return arr;
};

export var hasClass = function hasClass(cla, element) {
	if (element.className.trim().length === 0) return false;
	var allClass = element.className.trim().split(" ");
	return allClass.indexOf(cla) > -1;
};

export var addClass = function addClass(cla, element) {
	if (!_this.hasClass(cla, element)) {
		if (element.setAttribute) {
			element.setAttribute("class", element.getAttribute("class") + " " + cla);
		} else {
			element.className = element.className + " " + cla;
		}
	}
};

export var removeClass = function removeClass(cla, element) {
	if (_this.hasClass(cla, element)) {
		var reg = new RegExp("(\\s|^)" + cla + "(\\s|$)");
		element.className = element.className.replace(reg, "");
	}
};

export var isJSON = function isJSON(str) {
	if (typeof str == "string") {
		try {
			var obj = JSON.parse(str);
			if (str.indexOf("{") > -1) {
				return true;
			} else {
				return false;
			}
		} catch (e) {
			consoleLog("isJSON方法报错", e);
			return false;
		}
	}
	return false;
};

export var getAge = function getAge(strBirthday) {
	var returnAge = void 0,
	    birthYear = void 0,
	    birthMonth = void 0,
	    birthDay = void 0;
	var d = new Date();
	var nowYear = d.getFullYear();
	var nowMonth = d.getMonth() + 1;
	var nowDay = d.getDate();

	strBirthday += "";

	strBirthday = strBirthday.replace(/\//g, "").replace(/-/g, "");
	if (strBirthday.length == 8) {
		birthYear = strBirthday.substring(0, 4);
		birthMonth = strBirthday.substring(4, 6);
		birthDay = strBirthday.substring(6, 8);
	}

	if (nowYear == birthYear) {
		returnAge = 0;
	} else {
		var ageDiff = nowYear - birthYear;
		if (ageDiff > 0) {
			if (nowMonth == birthMonth) {
				var dayDiff = nowDay - birthDay;
				if (dayDiff < 0) {
					returnAge = ageDiff - 1;
				} else {
					returnAge = ageDiff;
				}
			} else {
				var monthDiff = nowMonth - birthMonth;
				if (monthDiff < 0) {
					returnAge = ageDiff - 1;
				} else {
					returnAge = ageDiff;
				}
			}
		} else {
			returnAge = -1;
		}
	}
	return returnAge;
};

export var getBirthday = function getBirthday(value) {
	var birthdayno = void 0,
	    birthdaytemp = void 0;
	if (value.length == 18) {
		birthdayno = value.substring(6, 14);
	} else if (value.length == 15) {
		birthdaytemp = value.substring(6, 12);
		birthdayno = "19" + birthdaytemp;
	} else {
		return "";
	}
	var birthday = birthdayno.substring(0, 4) + birthdayno.substring(4, 6) + birthdayno.substring(6, 8);
	return birthday;
};

export var getCustAge = function getCustAge(idCode) {
	var BIRTHDAY = getBirthday(idCode),
	    AGE = getAge(BIRTHDAY);
	return AGE;
};

export var getSex = function getSex(value) {
	var sexno = void 0,
	    sex = void 0;
	if (value.length == 18) {
		sexno = value.substring(16, 17);
	} else if (value.length == 15) {
		sexno = value.substring(14, 15);
	} else {
		return "";
	}
	var tempid = sexno % 2;
	if (tempid == 0) {
		sex = "1";
	} else {
		sex = "0";
	}
	return sex;
};

export var cutStrByByteLength = function cutStrByByteLength(str, length) {
	if (!str) {
		return str;
	}
	var result = "",
	    strlen = str.length,
	    chrlen = str.replace(/[^\x00-\xff]/g, "**").length;

	if (chrlen <= length) {
		return str;
	}

	for (var i = 0, j = 0; i < strlen; i++) {
		var chr = str.charAt(i);
		if (/[\x00-\xff]/.test(chr)) {
			j++;
		} else {
			j += 2;
		}
		if (j <= length) {
			result += chr;
		} else {
			return result;
		}
	}
};

export var cutCustFullName = function cutCustFullName(custFullName) {
	return cutStrByByteLength(custFullName, 16);
};

import gxRegionData from "../components/preEntry/citySelectData/cityselect-data";
import RegionData from "../components/preEntry/citySelectData/zt-cityselect-data";
import countryData from "../components/preEntry/countryselect-data";
export var parseAddress = function parseAddress(value, qsName) {
	var regionData = qsName == "ZHONGTAI" ? RegionData : gxRegionData;

	if (value && typeof value == "string") {
		var addrValue = value;
		var country = "";
		var region = [];
		var street = "";
		var zipCode = "";

		for (var i = 0; i < countryData.length; i++) {
			var data = countryData[i];
			if (addrValue.indexOf(data.cnName) === 0) {
				country = data.cnName;
				addrValue = addrValue.substr(data.cnName.length);
				break;
			}
		}

		street = addrValue;
		var parseRegion = function parseRegion(regionData, addressValue) {
			var _regionData = _.cloneDeep(regionData);

			if (region.length == 1 && _regionData.length == 1 && _regionData[0]["label"] == "不详" && addressValue.indexOf("不详") !== 0) {
				region.push("不详");
				_regionData = _.cloneDeep(_regionData[0]["children"]);
			}

			if (region.length == 2 && _regionData.length == 1 && _regionData[0]["label"] == "不详") {
				region.push("不详");
				_regionData = [];
			}
			_.each(_regionData, function (data, index) {
				if (addressValue.indexOf(data.label) === 0) {
					region.push(data.label);
					street = addressValue.substr(data.label.length);
					if (data.code) {
						zipCode = data.code;
					}
					if (data["children"]) {
						parseRegion(data["children"], street);
					}
					return false;
				}
			});
		};
		parseRegion(regionData, addrValue);

		region = _.merge(["不详", "不详", "不详"], region);
		return [country, region, street, zipCode];
	} else {
		return ["", [], "", ""];
	}
};

export var getAddressStr = function getAddressStr(value) {
	var addr = "";
	for (var i = 0; i < value.length; i++) {
		addr += CodeToText[value[i]];
	}

	return addr;
};

export var formatNumber = function formatNumber(num) {
	if (!/^(\+|-)?(\d+)(,\d{3})*(\.|\.\d+)?$/.test(num)) {
		return num;
	}
	var re = /(\d)(\d{3})(,|$)/,
	    a = RegExp.$1,
	    b = RegExp.$2,
	    c = RegExp.$4;
	while (re.test(b)) {
		b = b.replace(re, "$1,$2$3");
	}
	return a + "" + b + "" + c;
};

export var digitLength = function digitLength(num) {
	var eSplit = num.toString().split(/[eE]/);
	var len = (eSplit[0].split(".")[1] || "").length - +(eSplit[1] || 0);
	return len > 0 ? len : 0;
};

export var floatToInt = function floatToInt(num) {
	if (num.toString().indexOf("e") === -1) {
		return Number(num.toString().replace(".", ""));
	}
	var dLen = digitLength(num);
	return dLen > 0 ? num * Math.pow(10, dLen) : num;
};

export var multi = function multi(num1, num2) {
	var num1Changed = floatToInt(num1);
	var num2Changed = floatToInt(num2);
	var baseNum = digitLength(num1) + digitLength(num2);
	return num1Changed * num2Changed / Math.pow(10, baseNum);
};

export var divide = function divide(num1, num2) {
	var num1Changed = floatToInt(num1);
	var num2Changed = floatToInt(num2);
	return multi(num1Changed / num2Changed, Math.pow(10, digitLength(num2) - digitLength(num1)));
};

export var getCharLength = function getCharLength(str, n) {
	return _.isString(str) ? str.replace(/[^\x00-\xff]/g, "1234567890".substr(0, n || 2)).length : 0;
};

export var IDCardCheck = function IDCardCheck(num) {
	num = num.toUpperCase();

	if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
		consoleLog("输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。");
		return false;
	}

	var len = void 0,
	    re = void 0;
	len = num.length;
	if (len == 15) {
		re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
		var arrSplit = num.match(re);

		var dtmBirth = new Date("19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
		var bGoodDay;
		bGoodDay = dtmBirth.getYear() == Number(arrSplit[2]) && dtmBirth.getMonth() + 1 == Number(arrSplit[3]) && dtmBirth.getDate() == Number(arrSplit[4]);
		if (!bGoodDay) {
			return false;
		} else {
			var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
			var arrCh = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2");
			var nTemp = 0,
			    i;
			num = num.substr(0, 6) + "19" + num.substr(6, num.length - 6);
			for (i = 0; i < 17; i++) {
				nTemp += num.substr(i, 1) * arrInt[i];
			}
			num += arrCh[nTemp % 11];
			return true;
		}
	}
	if (len == 18) {
		re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
		var arrSplit = num.match(re);

		var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
		var bGoodDay;
		bGoodDay = dtmBirth.getFullYear() == Number(arrSplit[2]) && dtmBirth.getMonth() + 1 == Number(arrSplit[3]) && dtmBirth.getDate() == Number(arrSplit[4]);
		if (!bGoodDay) {
			return false;
		} else {
			var valnum = void 0;
			var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
			var arrCh = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2");
			var nTemp = 0,
			    i;
			for (i = 0; i < 17; i++) {
				nTemp += num.substr(i, 1) * arrInt[i];
			}
			valnum = arrCh[nTemp % 11];
			if (valnum != num.substr(17, 1)) {
				return false;
			}
			return true;
		}
	}
	return false;
};

export var parseDate = function parseDate(text) {
	var dt = text.split(" "),
	    hh = 0,
	    mm = 0,
	    ss = 0,
	    matchD = void 0,
	    year = void 0,
	    month = void 0,
	    dd = void 0,
	    hmsStr = void 0,
	    hms = void 0,
	    ymdStr = dt[0];
	if (dt.length == 2) {
		hmsStr = dt[1];
	}
	if (matchD = ymdStr.match(/^(\d{4})\D(\d{1,2})\D(\d{1,2})$/)) {
		year = matchD[1];
		month = matchD[2];
		dd = matchD[3];
	} else {
		if (ymdStr.length === 8) {
			year = ymdStr.substring(0, 4);
			month = ymdStr.substring(4, 6);
			dd = ymdStr.substring(6, 8);
		}
	}
	if (hmsStr) {
		hms = hmsStr.match(/^(\d{2})\D(\d{2})\D(\d{2})/);
		hh = hms[1];
		mm = hms[2];
		ss = hms[3];
	}

	return new Date(year, month - 1, dd, hh, mm, ss);
};

export var formatDate = function formatDate(dateTime, fmt) {
	fmt = fmt || "yyyy-MM-dd hh:mm:ss";
	if (_.isString(dateTime)) {
		dateTime = parseDate(dateTime);
	}
	if (!_.isDate(dateTime)) {
		return dateTime;
	}
	var o = {
		"M+": dateTime.getMonth() + 1,
		"d+": dateTime.getDate(),
		"h+": dateTime.getHours(),
		"m+": dateTime.getMinutes(),
		"s+": dateTime.getSeconds(),
		"q+": Math.floor((dateTime.getMonth() + 3) / 3),
		"S": dateTime.getMilliseconds() };
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (dateTime.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}
	}
	return fmt;
};

export var transDate = function transDate(dateStr) {
	dateStr = dateStr || "";
	if (/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(dateStr)) {
		return dateStr;
	} else {
		switch (dateStr) {
			case "":
			case "0":
				return "";
				break;
			case "30001231":
				return "长期";
				break;
			default:
				return formatDate(dateStr, "yyyy年MM月dd日");
				break;
		}
	}
};

export function getMarketByStkbd(stkbd) {
	var result = "";
	switch (stkbd) {
		case "00":
			result = "0";
			break;
		case "01":
			result = "2";
			break;
		case "10":
			result = "1";
			break;
		case "13":
			result = "5";
			break;
		case "20":
			result = "6";
			break;
		case "30":
			result = "6";
			break;
		case "21":
			result = "7";
			break;
		case "11":
			result = "3";
			break;
		case "03":
			result = "S";
			break;
	}
	return result;
}

export var calcTplHeight = function calcTplHeight(opts) {
	var calcNum = void 0,
	    $tmpWrap = $("<span>").appendTo("body").addClass("print-hide").css({
		"position": "absolute",
		"top": "-1000px",
		"left": "-1px",
		"white-space": "nowrap",
		"height": "auto",
		"line-height": opts.lh + "px"
	});

	opts.minNum = opts.minNum || 1;

	$tmpWrap.text(opts.str);
	calcNum = $tmpWrap.width() / opts.fixW;

	calcNum = Math.floor(opts.floor && calcNum > Math.floor(calcNum) ? calcNum + 1 : calcNum);
	$tmpWrap.remove();
	return calcNum > opts.minNum ? calcNum * opts.lh : opts.minNum * opts.lh;
};

export var cnnumtonum = function cnnumtonum(chnStr) {
	var chnNumChar = {
		零: 0,
		壹: 1,
		贰: 2,
		叁: 3,
		肆: 4,
		伍: 5,
		陆: 6,
		柒: 7,
		捌: 8,
		玖: 9
	};
	var chnNameValue = {
		拾: {
			value: 10,
			secUnit: false
		},
		佰: {
			value: 100,
			secUnit: false
		},
		仟: {
			value: 1000,
			secUnit: false
		},
		万: {
			value: 10000,
			secUnit: true
		},
		亿: {
			value: 100000000,
			secUnit: true
		}
	};
	var expNumChar = {
		拾: 10,
		拾壹: 11,
		拾贰: 12,
		拾叁: 13,
		拾肆: 14,
		拾伍: 15,
		拾陆: 16,
		拾柒: 17,
		拾捌: 18,
		拾玖: 19
	};
	if (expNumChar[chnStr]) {
		return expNumChar[chnStr];
	}
	var rtn = 0;
	var section = 0;
	var number = 0;
	var secUnit = false;
	var str = chnStr.split("");
	for (var i = 0; i < str.length; i++) {
		var num = chnNumChar[str[i]];
		if (typeof num !== "undefined") {
			number = num;
			if (i === str.length - 1) {
				section += number;
			}
		} else {
			var cunit = chnNameValue[str[i]];
			if (typeof cunit == "undefined") {
				return false;
			}
			var unit = chnNameValue[str[i]].value;
			secUnit = chnNameValue[str[i]].secUnit;
			if (secUnit) {
				section = (section + number) * unit;
				rtn += section;
				section = 0;
			} else {
				section += number * unit;
			}
			number = 0;
		}
	}
	return rtn + section;
};


//////////////////
// WEBPACK FOOTER
// ./src/tools/util.js
// module id = 35
// module chunks = 2